import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import tableConfigs from './useTableConfig'

const Table = ({ networkType, data, filters, processingIds, accountId }) => {
  const config = useMemo(() => tableConfigs[networkType], [networkType])

  const { tableState, tableConfig } = config(
    {
      filters,
      processingIds,
      networkType,
      accountId,
    },
    data,
  )

  return <List table={tableState} config={tableConfig} />
}

Table.propTypes = {
  networkType: PropTypes.string,
  accountId: PropTypes.string,
  data: PropTypes.array,
  checkboxHandleChange: PropTypes.func,
  checkedIDs: PropTypes.array,
  processingIds: PropTypes.array,
  filters: PropTypes.object,
}

export default Table
